import React from 'react';
import { PendingCall } from 'services/caller-id';
import { formatPhone } from 'utils/formatPhone';
import { CloseIcon, PhoneIcon } from './icons';

interface CallListSheetProps {
  calls: PendingCall[];
  onSms: (call: PendingCall) => void;
  onBook: (call: PendingCall) => void;
  onClose: () => void;
}

// State 2 — bottom sheet over the pending-caller-id list (source of truth;
// handled callers are dropped server-side, so every row here is unhandled).
// `time` is pre-formatted by the backend — displayed as-is.
const CallListSheet = ({ calls, onSms, onBook, onClose }: CallListSheetProps) => (
  <>
    <div className="cid-scrim" onClick={onClose} />
    <div className="cid-sheet">
      <div className="cid-sheet-grab"><span /></div>
      <div className="cid-sheet-header">
        <span className="cid-sheet-header-icon"><PhoneIcon size={18} /></span>
        <span className="cid-sheet-title">Caller ID · {calls.length} call{calls.length === 1 ? '' : 's'}</span>
        <button type="button" className="cid-sheet-close" onClick={onClose}><CloseIcon size={18} /></button>
      </div>
      <div className="cid-sheet-list">
        {calls.length === 0 && <div className="cid-sheet-empty">No calls</div>}
        {calls.map(call => {
          const known = !!call.customerName;
          return (
            <div key={call.id} className={`cid-call-card ${known ? 'known' : 'unknown'}`}>
              <span className="cid-call-card-body">
                <span className="cid-call-card-meta">Incoming · {call.time}</span>
                <span className="cid-call-card-name-row">
                  <span className="cid-call-card-name">{call.customerName || 'Unknown caller'}</span>
                  {!known && <span className="cid-badge-new large">new customer</span>}
                </span>
                <span className="cid-call-card-phone">{formatPhone(call.customerPhone)}</span>
              </span>
              <span className="cid-call-card-actions">
                <button type="button" className="cid-btn-sms" onClick={() => onSms(call)}>SMS</button>
                <button type="button" className="cid-btn-book" onClick={() => onBook(call)}>Book</button>
              </span>
            </div>
          );
        })}
      </div>
    </div>
  </>
);

export default CallListSheet;
